/**
 * Default payment details that pre-fill the confirmation PDF.
 *
 * Edit the values below with your real bank details, then redeploy.
 * (A BSB and account number for receiving money are not secret — they already
 * appear on every invoice you send — so it's fine to keep them here.)
 *
 * On the manage-bookings page these are used as the starting values; anything
 * you type into the "Payment details for PDFs" panel there is remembered in
 * your browser and takes precedence.
 */
export const PAYMENT_DEFAULTS = {
  accountName: 'Southern Comfort Camps',
  bsb: '086643', // e.g. '063-000'
  accountNumber: '868352836', // e.g. '12345678'
  payId: '', // optional: your PayID email or mobile
};
